const SystemSettingActionType = {
  GET_SYSTEM_SETTINGS: 'GET_SYSTEM_SETTINGS',
  SAVE_SYSTEM_SETTINGS: 'SAVE_SYSTEM_SETTINGS',
  RESET_SYSTEM_SETTINGS: 'RESET_SYSTEM_SETTINGS',

  EDIT_SYSTEM_SETTINGS: 'EDIT_SYSTEM_SETTINGS',
};

export default SystemSettingActionType;
